module.exports = new __parcel__URL__("rose.22a6e8e6.svg").toString();